
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {},
  "_MAPBOX_CONFIG": {
    "accessToken": "pk.eyJ1IjoiaHlwZWFkbWluIiwiYSI6ImNscHdvZzh4cDBkb2kyaHBidHA3bnBueGYifQ.s8KNgBNzKUQNJEaS-Tc0kw"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/app/.app/app.config.ts"
import cfg1 from "/app/layers/tairo/app.config.ts"
import cfg2 from "/app/node_modules/.pnpm/@shuriken-ui+nuxt@1.1.3_magicast@0.3.5_nuxt@3.13.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_5uke73qch6x65qqmuo2kunjxua/node_modules/@shuriken-ui/nuxt/app.config.ts"
import cfg3 from "/app/layers/tairo-layout-collapse/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, cfg1, cfg2, cfg3, inlineConfig)
